import { useCallback, useState } from "react";

export default function useForm(defaults) {
  let [values, setValues] = useState(defaults);
  let onChange = useCallback((field, value) => {
    setValues((values) => ({ ...values, [field]: value }));
  }, []);
  return [values, onChange];
}
